import { groupsJson } from "@/components/suggestions/providers/data";

import type { GroupTypeValue } from "@/components/suggestions/providers/data/types";
import type { OpeningSymbol, ClosingSymbol } from "@corca/data";

export const openingToClosingMap = Object.values(groupsJson).reduce(
  (acc, item) => ({
    ...acc,
    [item.openingSymbol.symbol]: item.closingSymbol.symbol,
  }),
  {} as Record<OpeningSymbol, ClosingSymbol>,
);

export const closingToOpeningMap = Object.values(groupsJson).reduce(
  (acc, item) => ({
    ...acc,
    [item.closingSymbol.symbol]: item.openingSymbol.symbol,
  }),
  {} as Record<ClosingSymbol, OpeningSymbol>,
);

export const openingSymbols = Object.values(groupsJson).map(
  ({ openingSymbol }) => openingSymbol.symbol,
);

export const closingSymbols = Object.values(groupsJson).map(
  ({ closingSymbol }) => closingSymbol.symbol,
);

export function isGroupOpeningSymbol(symbol: string): symbol is OpeningSymbol {
  return openingSymbols.includes(symbol as OpeningSymbol);
}

export function isGroupClosingSymbol(symbol: string): symbol is ClosingSymbol {
  return closingSymbols.includes(symbol as ClosingSymbol);
}

export function isGroupSymbol(symbol: string): symbol is OpeningSymbol | ClosingSymbol {
  return isGroupOpeningSymbol(symbol) || isGroupClosingSymbol(symbol);
}

export function getOpeningSymbolProps(openingSymbol?: OpeningSymbol) {
  const key = Object.keys(groupsJson).find((groupType) => {
    return groupsJson[groupType as GroupTypeValue].openingSymbol.symbol === openingSymbol;
  }) as GroupTypeValue | undefined;

  return key ? groupsJson[key].openingSymbol : undefined;
}

export function getClosingSymbolProps(closingSymbol?: ClosingSymbol) {
  const key = Object.keys(groupsJson).find((groupType) => {
    return groupsJson[groupType as GroupTypeValue].closingSymbol.symbol === closingSymbol;
  }) as GroupTypeValue | undefined;

  return key ? groupsJson[key].closingSymbol : undefined;
}
